<template>
  <div>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-img 
              :alt="platformName"  
              contain 
              height="48px" 
              :src="require('@/assets/icons/unl.png')">
            </v-img>

            <h3 class="headline text-center pt-2">
              {{ platformName }}
            </h3>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-text>
        <label>Complete el siguiente formulario para registrarse en la plataforma:</label>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outline
                label="Nombre"
                type="text"
                v-model="name">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Apellido"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="DNI/Pasaporte/Cédula"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Tipo de participante"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Institución de la que proviene"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Carrera o profesión"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Empresa o institución de la que sos parte"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Si tenés un emprendimiento, contanos cómo se llama"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Teléfono movil (+cod país + cód área + número)"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="¿Cómo te enteraste de la actividad?"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Linkedin"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Facebook"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Twitter"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Instagram"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Máximo nivel de estudios que alcanzaste."
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="¿Querés recibir información de JIJE y otras novedades en tu celular? "
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Correo electrónico"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Contraseña"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outline
                label="Confirmar contraseña"
                type="text"
                v-model="lastname">
              </v-text-field>
            </v-col>
          </v-row>
            
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
        <v-row>
          <v-col cols="12">
            <v-btn 
              color="info" 
              :large="$vuetify.breakpoint.smAndUp" 
              :loading="loading"
              block
              :disabled="!terms_condition_accepted"
              @keyup.enter="fieldsValidate()"
              @click="fieldsValidate">
              <v-icon left>lock</v-icon>
              Registrarse
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
   name: 'PostulateProject',
   props: {
      edition: String
   },
   data: () => ({
      dialog:false,
      error_dialog:false,
      loading:false,
      darkTheme: true,
      platformName:'JIJE UNL',
      name:'',
      lastname:'',
      email:'',
      password: '',
      terms_condition_accepted:false,
      emailRules: [ 
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v),
        v => this.validate(v)
      ],
      passwordRules: [ 
          v => !!v || "El campo es requerido",
          v => ( v && v >= 5 ) || "La contraseña debe tener al menos 5 caracteres",
          v => ( v && v <= 25 ) || "La contraseña no debe tener mas de 50 caracteres",
      ],
      error:'',
      errors:[],
      slug:null,
      convocation:[]
    }),
    computed: {
    ...mapGetters([
      'isLogged', 'user'
      ])
    },
    methods: {
      validate(a){
         if(a){
            return false
         }
         return true
      },

      fieldsValidate(){
        this.errors = []

        if(this.name.length==0){
          this.errors.push('- Por favor ingrese su nombre')
        }
        if(this.lastname.length==0){
          this.errors.push('- Por favor ingrese su apellido')
        }
        if(this.password.length<8){
          this.errors.push('- La contraseña debe tener al menos 8 caracteres')
        }
        if(!this.validateEmail(this.email)){
          this.errors.push('- El correo electrónico ingresado no es valido')
        }

        if(this.errors.length==0){
          this.register()
        }else{
          this.error_dialog = true
        }
      },

      validateEmail(email) {
        var re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i 
        return re.test(email);
      },

      async getInfoEdition(){
        await axios.get('index/convocation/'+this.edition).then(response =>{
          if(!response.data.convocation){
            this.$router.push({ name: 'CheckConvocations' })   
            this.loading=false
          }else{
            this.convocation = response.data.convocation
            this.loading=false
          }
          
        }).catch(error => {
          console.log(error)
          if(error.response.status===404){
            this.$router.push({ name: 'UNLPotencia' })  
          }
        })
      },

      register () {
         this.loading=true
         this.$store
         .dispatch('register', {
            name:this.name,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            edition_id: this.convocation.id,
         })
         .then(() => {
            this.$router.push({ name: 'CheckConvocations' })   
            this.loading=false
         })
         .catch(() => {
            this.loading=false
            this.errors = []
            this.errors.push('Detectamos que en esta edición, tu correo electrónico ya se encuentra en uso')
            this.error_dialog = true
         })
      },

      cheakIsLogin(){
        if(this.isLogged){
          this.$router.push({ name: 'home' })
        }
      }
   },
   created(){
    // this.getInfoEdition()
    // this.cheakIsLogin()
   }
};
</script>